import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '@draeger-academy/common';
import { TranslateModule } from '@ngx-translate/core';
import { DwVideoModule } from '../video';
import { DaProgressiveImageModule } from '../da-progressive-image/da-progressive-image.module';
import { DaButtonModule } from '../da-button/da-button.module';
import { DaLinkModule } from '../da-link/da-link.module';
import { LinkListBoxModule } from '../link-list-box/link-list-box.module';
import { AccordionBoxComponent } from './accordion-box.component';

@NgModule({
    declarations: [AccordionBoxComponent],
    imports: [
        CommonModule,
        LinkListBoxModule,
        PipesModule,
        DaLinkModule,
        DaButtonModule,
        DaProgressiveImageModule,
        DwVideoModule,
        TranslateModule
    ],
    exports: [AccordionBoxComponent]
})
export class AccordionBoxModule {}
